import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";

export default function Layout() {
  return (
    <div className="layout">
      <Header />
      <main className="main-content">
        <Outlet />
      </main>
      {/* Footer Section */}
      <footer className="py-6 px-8 bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto text-center text-sm text-gray-500">
          <div className="space-x-4">
            <a href="#" className="hover:text-indigo-600 transition">
              Privacy Policy
            </a>
            <span className="text-gray-300">|</span>
            <a href="#" className="hover:text-indigo-600 transition">
              Terms of Service
            </a>
            <span className="text-gray-300">|</span>
            <a href="#" className="hover:text-indigo-600 transition">
              Contact
            </a>
            <span className="text-gray-300">|</span>
            <a href="#" className="hover:text-indigo-600 transition">
              Help Center
            </a>
          </div>
          <p className="mt-3">
            &copy; {new Date().getFullYear()} Songzug. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
